export class LinguaVO {
  id: string;
  codice: string;
  nome: string;
  output: string;
}
